import { MMButton } from '@components'
import cn from '@integrations/classnames'
import { useContext } from '@integrations/react'
import { GlobalContext, tr } from 'mmfintech-commons'

import styles from './IbanRequest.module.scss'

// Rendered inside the global ModalDialog (opened via modalShow), so it stacks above the wizard
// overlay. "I understand" just hides the global modal and returns the user to the wizard.
function IbanFeeTermsModal() {
  const { modalHide } = useContext(GlobalContext)

  return (
    <div className={cn(styles['iban-fee-terms-modal'])} data-test='iban-fee-terms-modal'>
      <div className={cn(styles['iban-fee-terms-title'])}>
        {tr('FRONTEND.IBAN_REQUEST.FEE_TERMS.TITLE', 'IBAN issuing fee — terms')}
      </div>
      <div className={cn(styles['iban-fee-terms-body'])}>
        <p>
          <strong>{tr('FRONTEND.IBAN_REQUEST.FEE_TERMS.ONE_TIME_TITLE', 'One-time fee.')}</strong>{' '}
          {tr(
            'FRONTEND.IBAN_REQUEST.FEE_TERMS.ONE_TIME',
            'The IBAN issuance fee is charged once per customer. After payment, all future IBANs issued under this account are free of issuance fees.'
          )}
        </p>
        <p>
          <strong>{tr('FRONTEND.IBAN_REQUEST.FEE_TERMS.REFUND_TITLE', 'Refund policy.')}</strong>{' '}
          {tr(
            'FRONTEND.IBAN_REQUEST.FEE_TERMS.REFUND',
            'If issuance fails at our partner bank, the fee is refunded in full within 24 hours and your fee-paid status is reset.'
          )}
        </p>
        <p>
          <strong>{tr('FRONTEND.IBAN_REQUEST.FEE_TERMS.NO_REFUND_TITLE', 'No refund on successful issuance.')}</strong>{' '}
          {tr('FRONTEND.IBAN_REQUEST.FEE_TERMS.NO_REFUND', 'Once the IBAN is issued the fee is non-refundable.')}
        </p>
      </div>
      <MMButton
        type='button'
        variant='primary'
        caption={tr('FRONTEND.BUTTONS.I_UNDERSTAND', 'I understand')}
        onClick={() => modalHide()}
        data-test='iban-fee-terms-close'
        fullWidth
      />
    </div>
  )
}

export default IbanFeeTermsModal
